import { module } from 'modujs';
import { $screen } from '../stores/screen';
import { ENV } from '../config';

export default class extends module {
    constructor(m) {
        super(m);

        this.id = this.getData('id');
    }    

    // This gets called by `Load.js` to make sure we properly center the pin *after* the dialog entry animation
    // If we're not in a modal, this module won't do anything
    start(duration = 1) {
        this.call('setTabByObjectId', this.id, 'Explore'); // Make sure we're in proper tab using our ID

        clearTimeout(this.timeout);        
        this.timeout = setTimeout(() => {            
            this.focus(duration)
            this.bindEvents();
        }, ENV.PREFERS_REDUCED_MOTION ? 100 : 1000)
    }

    focus(duration = 1) {
        this.call('focusLocation', {id: this.id, exclusive: true, duration }, 'Explore') 
    }

    bindEvents() {
        this.unbindScreenListener = $screen.listen(this.onResize.bind(this))
    }

    unbindEvents() {
        this.unbindScreenListener?.();
    }

    // we also need to update the pin centering when the screen resizes
    onResize() {    
        clearTimeout(this.timeout);    
        this.timeout = setTimeout(() => {
            this.focus()
        }, 1000);
    }

    destroy() {
        super.destroy();
        clearTimeout(this.timeout);
        this.unbindEvents();        
    }
}
 